import React from "react";
import Skeleton from 'react-loading-skeleton'

const SkeletonCourseCard = (props) => {
    let quantity = props.quantity ? props.quantity : 1
    return(
        <>
        {[...Array(quantity)].map((x, i) =>
            <div className={props.col}>
                <Skeleton 
                    height="200px"
                    count={1}
                    className="mb-10"
                />
                <Skeleton 
                    count={1}
                    width="60%"
                />
                <Skeleton 
                    count={1}
                    width="80%"
                />
                <Skeleton 
                    count={1}
                    width="100%"
                />
            </div>
        )}
        </>
    )
}
export default SkeletonCourseCard;